<template>
  <div style="width:100%;height:100%;position:relative;">
    <div class="flex-wrap pd-embed-value" :class="{
        'pd-embed-empty-value':!value
      }"
       @click="modalSelector=true">
      {{'点击配置'}} ({{ value.length }})
    </div>

    <Modal v-model="modalSelector" width="800" title="选项编辑器" footer-hide>
      <div style="padding:10px">
        <div v-if="config.url">已指定远程获取 {{ config.url }}</div>
        <div>
          <Input type="textarea" :rows="4"
            placeholder="批量添加，采用空格或者','为分隔符"
            v-model="raw_text"
           />
           <div class="flex-wrap flex-center" style="margin-top:10px">

            <Button icon="md-add" @click="handleAddRaw">批量添加</Button>

           </div>
        </div>
        <div  v-if="samples && samples.length > 0">
          预设选项
          <template v-for="s in samples">
            <Button @click="setValue(s.value)"  style="margin-left:5px;" size="small">{{s.name}}</Button>
          </template>
        </div>
        <BaseFlexTablePro
        style="margin-top:10px;border:1px solid var(--border)"
          :editable="config.url?false:true"
          :columns="cols"
          v-model="_val"
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import {cloneDeep} from 'lodash';

export default {
  data() {
    return {
      form: {},
      items: [],
      raw_text: '',
      modalSelector: false,
    };
  },
  props: ['value', 'db', 'option'],
  computed: {
    samples() {
      return this.option?.samples || [];
    },
    config() {
      return {...this.db,...this.option}
    },
    cols() {
      const def_cols = [
        {key: 'drag', name: '拖', control: 'drag'},
        {key: 'index', name: '序', control: 'index'},
        {key: 'name', name: '名称', control: 'Input', width: 'auto', span: 8,option:{
          number:this.db['value-type'] == 'number'
        }},
        {key: 'key', name: '值', control: 'Input', width: 100, span: 8},
      ];
      if (this.config.simple) {
        return def_cols.slice(0, 3);
      } else {
        return def_cols;
      }
    },
    _val: {
      set(e) {
        this.$emit('input', e);
      },
      get() {
        if(!Array.isArray(this.value))
          return []
        if (this.value.length > 0 && typeof this.value[0] == 'string') {
          return this.value.map((v, i)=>({
            name: v, key: i,
          }));
        } else {
          return this.value;
        }
      },
    },
  },
  watch: {
    'config.url': {
      handler(url) {
        if (url) {
          this.getRemoteData(url);
        }
      },
      immediate: true,
      deep: true,
    },

    'db.simple': {
      handler(simple) {
        if (this._val && this._val.length > 0) {
          if (simple && typeof this._val[0] == 'object') {
            this._val = this._val.map((v)=>v.name);
          }
          if (!simple && typeof this._val[0] == 'string') {
            this._val = this._val.map((v, i)=>({key: i, name: v}));
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    setValue(v) {
      this._val = cloneDeep(v);
    },
    handleAddRaw() {
      let raw = this.raw_text;
      if (raw && raw.trim()) {
        let sep = ' ';
        [',', '|', ';', '\n'].forEach((s)=>{
          if (raw.includes(s)) {
            sep = s;
          }
          raw = raw.replaceAll('\'', '').replaceAll('"', '');
        });
        const items = raw.split(sep).map((v)=>v.trim()).filter((v)=>v);
        if (this.config.simple) {
          this._val = this._val.concat(items.map((v)=>({key: v, name: v})));
        } else {
          this._val = this._val.concat(items.map((v, i)=>({key: i, name: v})));
        }
      }
    },
    getRemoteData(url) {
      if (!url) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(()=>{
        this.$api.afterLogin(()=>{
          this.$api.get(url).then((res)=>{
            if (Array.isArray(res.data.data)) {
              const items = res.data.data;

              this._val = items.map((v)=>({key: v.id, name: v.name}));
            } else {
              this._val = [];
            }
          }).catch((e)=>{
            this.items = [];
          });
        });
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
